/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ClusterNameFilters {
  /**
  * Matches if any string in this list equals `clusterName`.
  */
  '_in'?: Array<string>;
  /**
  * Matches if no string in this list equals `clusterName`.
  */
  'notIn'?: Array<string>;
  /**
  * Matches if any string in this list is a substring of `clusterName`.
  */
  'contains'?: Array<string>;
  /**
  * Matches if no string in this list is a substring of `clusterName`.
  */
  'notContains'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "contains",
      "baseName": "contains",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "notContains",
      "baseName": "notContains",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ClusterNameFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

